/*
 * La nuit des notifications et l'heure des rappels du jour (chantier notifications-socle ; ici
 * depuis notifications-sortes, ticket 04) : écrites une fois, le moteur des notifications
 * (`server/src/domain/notifications/`) les applique, la route des réglages refuse par elles, et le
 * panneau du téléphone ne propose que ce qu'elles permettent. Les heures se comptent à l'heure
 * pleine, de 0 à 23.
 */
/** Une heure pleine tombe dans la nuit (début compris, fin exclue). Une nuit sans durée n'en est pas une. */
export function heurePleineDansLaNuit(h, nuit) {
    if (nuit.debut === nuit.fin)
        return false;
    return nuit.debut < nuit.fin ? h >= nuit.debut && h < nuit.fin : h >= nuit.debut || h < nuit.fin;
}
/** Une heure « hh:mm » tombe dans la nuit, à son heure pleine. */
export function dansLaNuit(heure, nuit) {
    return heurePleineDansLaNuit(Number(heure.slice(0, 2)), nuit);
}
/** Une nuit qui dure, et l'heure des rappels du jour hors de cette nuit. */
export function nuitEtRappelsPermis(nuit, heureDesRappels) {
    return nuit.debut !== nuit.fin && !heurePleineDansLaNuit(heureDesRappels, nuit);
}
